export default {
  "common":{
    "register": "注册",
    "chinese": "中文",
    "english": "英语",
    "khmer": "高棉语",
    "welcome": "欢迎",
    "captcha": "验证码",
    "sendCaptcha": "发送验证码",
    "china": "中国",
    "cambodia": "柬埔寨",
    "reSendCaptcha": "{s}秒后再发送",
    "openELiveToView": "打开E-Live,看更多精彩视频",
    "openELive": "打开E-Live",
    "openToView": "打开看看",
    "inviteToELive": "邀请您一起玩<span style='color: #FF4C77;'>E-Live</span>",
    "iHaveRead": "我已阅读并同意",
    "userProtocol": "用户协议",
    "privacyPolicy": "隐私政策",
  },
  "placeholder": {
    "phone": "请输入手机号",
    "captcha": "请输入验证码",
    "searchText": "请输入搜索关键词",
  },
  "required": {
    "phone": "手机号不能为空",
    "captcha": "验证码不能为空",
  }
}